import en from './en-US'
import vi from './vi-VI'
import ko from './ko-KR'
import zh from './zh-CN'

export default {
  en, vi, ko, zh
}